module.exports = __webpack_public_path__ + "static/media/sudoku4.aa3f4a17.png";